<template>
	<a-page-header
		class="mb-5"
		style="border: 1px solid rgb(235, 237, 240)"
		title="Groups & Categories"
		@back="() => $router.go(-1)"
	>
	</a-page-header>
</template>

<script>
export default {
	name: 'SettingTitle',
	components: {},
}
</script>

<style></style>
